module.exports = __webpack_public_path__ + "static/img/jhulogo.28fcfec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jhulogo.png
// module id = gda6
// module chunks = 1